import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

import { IPreCreatedBetBuilderLongList } from '../models/pre-created-bet-builder.model';
import { PreBetBuilderListComponent } from '../precreatedBetBuilderList/pre-bet-builder-list.component';

@Component({
    selector: 'pre-created-bet-builder-container',
    standalone: true,
    templateUrl: './pre-created-bet-builder-container.component.html',
    imports: [CommonModule, PreBetBuilderListComponent],
})
export class PreCreatedBetBuilderContainerComponent {
    preCreatedBetslipEvents = input.required<IPreCreatedBetBuilderLongList>();
}
